module.exports = __webpack_public_path__ + "static/media/usr_13.225da386.png";